<template>
    <slot :init-excentos="initExcentos" />
    <MiscExcentosModal ref="excentosModal" />
</template>

<script setup lang="ts">
import type { MiscExcentosModal } from '#components'

const excentosModal = ref<InstanceType<typeof MiscExcentosModal>>()
const excentosLanguageCode = ref()
const config = useRuntimeConfig().public
const { currency } = useSessionContext()
const country = config.platformCountries.find((c) => c.id === config.platformDefaults.countryId)?.iso?.toLowerCase() ?? ''
const { localeProperties } = useI18n()
const { product } = useProduct()
const { handleExcentosAddToCart, handleExcentosAddToWishlist } = useExcentos({
    onStart: () => { excentosModal.value?.setLoading(true) },
    onCartSettled: () => {
        excentosModal.value?.close()
        excentosModal.value?.setLoading(false)
    },
    // A wishlist add deliberately leaves the configurator open (A4G-3275). Dropping the
    // loading gate is what reveals it again — the gate's overlay is opaque, and unlike the
    // cart path there is no `close()` here to hide it behind.
    onWishlistSettled: () => { excentosModal.value?.setLoading(false) },
})

const sku = computed(() => {
    return product?.value?.customFields?.custom_fit_sku != null ? product?.value?.customFields?.custom_fit_sku : product?.value?.productNumber
})

onMounted(() => {
    // Get current locale language code (e.g. en-GB) and reformat to excentos friendly format (e.g. en_GB)
    excentosLanguageCode.value = localeProperties?.value?.language?.replace('-', '_')

    // Register event listeners
    window.addEventListener('dataLayerPush', handleExcentosAddToCart)
    window.addEventListener('dataLayerPush', handleExcentosAddToWishlist)
})

onBeforeUnmount(() => {
    window.removeEventListener('dataLayerPush', handleExcentosAddToCart)
    window.removeEventListener('dataLayerPush', handleExcentosAddToWishlist)
})

function initExcentos () {
    excentosModal.value?.open(buildExcentosScriptUrl())
}

function buildExcentosScriptUrl() {
    //service.excentos.com/all4golf/DE/app_All4Golf_Clubs/de_DE/loadadvisor?theme=all4golf-sunrise&xcScheme=https&xcReset&$sku=5139629&$currency=eur
    //stage.excentos.com/all4golf/DE/app_All4Golf_Clubs/de_DE/loadadvisor?theme=all4golf-sunrise&xcScheme=https&xcReset&$sku=5087155&$currency=eur
    const baseUrl = config.excentosScriptTemplate
        .replace('{LANG}', excentosLanguageCode.value != null ? excentosLanguageCode.value : 'en_GB')
        .replace('{SKU}', sku.value)
        .replace('{CURRENCY}', currency?.value?.isoCode?.toLowerCase() || '')
    return country ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}$country=${country}` : baseUrl
}
</script>
